import { authentication } from './authentication';
import { name } from './name';
import { role } from './role';

export const columns = [name, role, authentication];
